export const JOURNEY_STAGES = [
  { key: "pre_qualified", label: "Pre-Qualified", nudge: "Next: get fully pre-approved with your lender." },
  { key: "pre_approved", label: "Pre-Approved", nudge: "Next: start touring homes that fit your criteria." },
  { key: "touring", label: "Touring", nudge: "Review each home before your tour and score it against your must-haves." },
  { key: "offer", label: "Offer", nudge: "Work with your agent to prepare and submit your offer." },
  { key: "under_contract", label: "Under Contract", nudge: "Your offer was accepted — inspections and timelines come next." },
  { key: "inspection", label: "Inspection", nudge: "Go over the inspection findings with your agent before moving ahead." },
  { key: "closing", label: "Closing", nudge: "Final paperwork and funding are underway — stay close with your lender and escrow." },
  { key: "keys", label: "Keys", nudge: "Welcome home! Your keys are in hand. Enjoy your new place." },
];

export const stageIndex = (key) => {
  const i = JOURNEY_STAGES.findIndex((s) => s.key === key);
  return i < 0 ? 0 : i;
};

export const isAtOrPast = (stageKey, key) => stageIndex(stageKey) >= stageIndex(key);

export const wishCriteria = (profile) => [...(profile?.must_haves || []), ...(profile?.nice_to_haves || [])];

export const wishScore = (tour, profile) => {
  const crit = wishCriteria(profile);
  if (!Array.isArray(tour?.wish_matches) || crit.length === 0) return null;
  const met = crit.filter((c) => tour.wish_matches.includes(c)).length;
  return { met, total: crit.length, pct: Math.round((met / crit.length) * 100) };
};

export const currentStageKey = (client) =>
  client?.journey_stage && JOURNEY_STAGES.some((s) => s.key === client.journey_stage)
    ? client.journey_stage
    : JOURNEY_STAGES[0].key;
